import {VenueContactData} from "../venue-contact/venue-contact.data";

export class Option {
    id: string;
    name: string;
}

export class SalesHandoverFieldTypeConfig {
    options: Option[];
}

export class SalesHandoverField {
    id: string;
    name: string;
    type: string;
    value: string;
    required: boolean;
    typeConfig: SalesHandoverFieldTypeConfig;
}

export class SalesHandoverData {
    fields: SalesHandoverField[];
    siteContact: VenueContactData;
}
